import React, {Component} from 'react';
import { injectIntl } from "react-intl";
import {messages} from "../../common/Translations";

class CompanyPortalSelect extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        let selectedPortalId = this.props.sortableList.portalId || null;

        return (
            <div className="form-group">
                <select className="form-control" onChange={s => this.props.onPortalSelect(s.target.value)} defaultValue={selectedPortalId}>
                    <option value="">{this.props.intl.formatMessage(messages.allPortals)}</option>
                    {
                        this.props.portals.map(
                            portal => <option key={portal.id} value={portal.id}>{portal.name}</option>
                        )
                    }
                </select>
            </div>
        );
    }
}

export default injectIntl(CompanyPortalSelect);


// WEBPACK FOOTER //
// ./web/src/components/company/list/CompanyPortalSelect.jsx